var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRectangleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 334,
  height: 334,
  fill: "none",
  viewBox: "0 0 334 334"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 324,
  height: 324,
  x: 5,
  y: 5,
  stroke: "#fff",
  strokeDasharray: "2 2",
  strokeWidth: 10,
  opacity: 0.5,
  rx: 7
})));
export { SvgRectangleIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzM0IiBoZWlnaHQ9IjMzNCIgdmlld0JveD0iMCAwIDMzNCAzMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuNSIgeD0iNSIgeT0iNSIgd2lkdGg9IjMyNCIgaGVpZ2h0PSIzMjQiIHJ4PSI3IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEwIiBzdHJva2UtZGFzaGFycmF5PSIyIDIiLz4KPC9zdmc+Cg==";